<div [ngClass]="getTheme">
  <!-- default -->
  <button
    [id]="id"
    class="action-button"
    [ngClass]="{
      linked: hasTickIcon,
      error: hasErrorIcon
    }"
    [disabled]="isDisabled"
    aria-describedby="errorID"
    (click)="handleClick()"
    (blur)="handleBlur()"
    type="button"
    [class.ng-invalid]="error"
  >
    <i class="fa fa-pencil-square-o" aria-hidden="true" *ngIf="hasEditIcon"></i>
    <i class="fa fa-plus" aria-hidden="true" *ngIf="hasPlusIcon"></i>
    {{
      refundAmount
        ? (buttonLabelKey | i18next: { refund: refundAmount | currency })
        : (buttonLabelKey | i18next)
    }}
    <div class="loader" *ngIf="hasLoadingIcon">
      <mat-spinner aria-label="loader"></mat-spinner>
    </div>
  </button>
  <span class="app-error-text" id="errorID">
    {{ errorTextKey && error ? (errorTextKey | i18next) : '' }}
  </span>
</div>
